import { HeaderLeft } from 'components/minute/layout/HeaderLeft';
import { MinuteHeaderRight } from 'elements/layout/minute/MinuteHeaderLayout/MinuteHeaderRight';
import styled from 'styled-components/macro';

export interface Props {
    children: React.ReactNode;
    className?: string;
}

export const MinuteHeaderPanel = (props: Props): JSX.Element => {
    return (
        <S_MinuteHeaderPanel className={props.className}>
            <HeaderLeft />
            <S_Center>{props.children}</S_Center>
            <MinuteHeaderRight />
        </S_MinuteHeaderPanel>
    );
};

const S_MinuteHeaderPanel = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
`;

const S_Center = styled.div`
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    align-items: center;
`;
